import { createFileRoute } from "@tanstack/react-router";

import { PraxaConnectedWorkSurface } from "../components/praxa/PraxaConnectedWorkSurface";
import { parsePraxaConnectedWorkSearch } from "../praxaConnectedWork";

export const Route = createFileRoute("/w/$workspaceId/connected-work")({
  component: PraxaConnectedWorkRoute,
  validateSearch: parsePraxaConnectedWorkSearch,
});

function PraxaConnectedWorkRoute() {
  const { workspaceId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PraxaConnectedWorkSurface initialItemId={search.item ?? null} workspaceId={workspaceId} />
  );
}
